import { render } from "./LogsTable.vue?vue&type=template&id=4d6264e2&scoped=true"
import script from "./LogsTable.vue?vue&type=script&lang=js"
export * from "./LogsTable.vue?vue&type=script&lang=js"

import "./LogsTable.vue?vue&type=style&index=0&id=4d6264e2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d6264e2"]])

export default __exports__